import React from "react"
import { Text, Flex } from "@chakra-ui/react"
import { colors } from "@app/theme/colors"
import Icon from "@components/Icon/Icon"

const FiltersSelectedComponent: React.FC = (props: any) => {
  const buildTextLabel = (label: string, replace: boolean) => {
    const sizeMap = {
      "1KG": "1kg (0000000)",
      "2KG": "2kg (000000)",
      "3KG": "3kg (00000)",
      "4KG": "4kg (0000)",
      "0000": "NB (0000)",
      "000": "0-3m (000)",
      "00": "3-6m (00)",
      "6-12m": "6-12m (0)",
      0: "6-12m (0)",
      1: "12-18m (1)",
      2: "18-24m (2)",
    }

    if (typeof label === "number") {
      return label
    }

    if (sizeMap[label]) {
      return sizeMap[label]
    }

    if (replace) {
      return label.replace(/-/g, " ")
    }

    return label
  }

  return props.selectedFilters?.length > 0 ? (
    <Flex position="relative" mr={1} flexWrap={`wrap`} gap={1}>
      {props?.selectedFilters?.map((filter, idx) =>
        filter?.key === "price" ? (
          // <pre>{JSON.stringify(filter.value, null, 2)}</pre>
          <Flex
            bg={colors.brand.beige.light}
            px={"12px"}
            py={"4px"}
            borderRadius={"999px"}
            key={idx}
            alignItems={"center"}
            justifyContent={"center"}
            cursor="pointer"
            onClick={() => {
              props.handleRemove(filter.key)
            }}
          >
            <Text size="xs" textTransform={"capitalize"}>
              ${filter.value[0]} &mdash; ${filter.value[1]}
            </Text>
            <Icon color={colors.text.primary} mt={"3px"} ml={"2px"} name="close" size="8px"></Icon>
          </Flex>
        ) : (
          <>
            {filter.value.map((selected, idx2) => {
              return (
                <Flex
                  bg={colors.brand.beige.light}
                  px={"12px"}
                  py={"4px"}
                  borderRadius={"999px"}
                  key={idx2}
                  alignItems={"center"}
                  justifyContent={"center"}
                  cursor="pointer"
                  onClick={() => {
                    props.handleRemove(filter.key)
                  }}
                >
                  <Text size="xs" textTransform={"capitalize"}>
                    {buildTextLabel(selected, true)}
                  </Text>
                  <Icon color={colors.text.primary} mt={"3px"} ml={"2px"} name="close" size="8px"></Icon>
                </Flex>
              )
            })}
          </>
        )
      )}
    </Flex>
  ) : null
}

export default FiltersSelectedComponent
